import * as yup from "yup";

export const cancelOrderFormSchema = yup.object({
  orderId: yup.string().required(),
  cancellationReason: yup
    .string()
    .required("This field is required")
    .min(10, "Cancellation reason field should contain at least 10 letters")
});
